import React, { useEffect, useState } from 'react';
import { Link, Routes, Route, NavLink, Outlet } from 'react-router-dom';
import { useApi } from '../../context/ApiProvider';
import ActivityIndicator from '../Helpers/ActivityIndicator'
import Card from '../Helpers/Card';
import Billing from './Billing';
import PartnerStatistics from './PartnerStatistics';
import { useLocale } from '../../localization/LocaleProvider';


export default function Partners(props) {
    return (
    <Routes>
        <Route path="/*" element={<Layout />}>
            <Route index element={<PartnerView view="overview" />} />
            <Route path="billing" element={<PartnerView view="billing" />} />
            <Route path="statistics/*" element={<PartnerView view="statistics" />} />
        </Route>
    </Routes>
    );
}

function Layout(props) {
    const { translate } = useLocale();
    
    return(
        <>
        <section className='spaceBetween flexCenter orgTop'>
        <h2>Partners</h2>

      </section>
        <div className='grid-container nowrap'>
        <nav className="organisationMenu">
          <ul className="nav">
            <li>
              <NavLink to="" end className={({ isActive }) =>
                isActive ? 'active' : undefined
              }>{translate("Overview")}</NavLink>
            </li>
            <li>
              <NavLink to="billing" className={({ isActive }) =>
                isActive ? 'active' : undefined
              }>{translate("Payments & Billing")}</NavLink>
            </li>
            {/*<li>
                <NavLink to="statistics" className={({ isActive }) =>
                isActive ? 'active' : undefined
                }>Statistics</NavLink>
            </li>*/}
            </ul>
        </nav>
        <Outlet />
        </div>
        </>
    )
}

function PartnerView(props) {
    const { view } = props;
    return (
        <div className='grid-container'>
            <section className='grow'>
                {view === 'overview' && <PartnerOverview />}
                {view === 'billing' && <Billing />}
                {view === 'statistics' && <PartnerStatistics />}
            </section>
        </div>
    )
}


function PartnerOverview(props) {
    const [partner, setPartner] = useState(false);
    const [clients, setClients] = useState([]); //Klienter som är kopplade till partnern
    const [administrators, setAdministrators] = useState([]); //Administratörer som är kopplade till partnern
    const [loading, setLoading] = useState(true);
    const [session, setSession] = useState(false);
    const Api = useApi();
    const { translate } = useLocale();


    useEffect(() => {
        Api.getSession().then(session => {
            if (!session?.ID) {
                setSession(false);
                return;
            }

            Api.get(`/administrators/${session.ID}`).then(user => {
                setSession(user);
              })
        })
    }, []);

    useEffect(() => {
        if(!session) {
            return;
        }

        refresh();
    }, [session]);

    function refresh() {
        setLoading(true);
        Promise.all([
            fetchPartner(),
            fetchPartnerClients(),
            fetchAdministrators(),
        ]).finally(() => {
            setLoading(false);
        });
    }

    function fetchPartner() {
        return Api.get(`/rolf/partners/${session.partnerId}`).then(response => {
            setPartner(response);
            return response;
        }).catch(() => {
            setPartner(false);
            return false;
        });
    }

    function fetchPartnerClients() {

        return Api.get(`/rolf/partners/${session.partnerId}/clients`).then(response => {
            if(!response) return [];
            setClients(response);
            return response;
        }).catch(() => {
            setClients([]);
            return [];
        })
    }

    function fetchAdministrators() {
        return Api.get(`/rolf/partners/${session.partnerId}/administrators`).then(response => {
            setAdministrators(response);
            return response;
        }).catch(() => {
            setAdministrators([]);
            return [];
        });
    }

    if(loading) {
        return <ActivityIndicator color="black" />
    }

    return(
        partner &&
        <>
        <div>
            <h3>{partner.name}</h3>
        </div>
         <div className='grid-container'>
            <section>
                <h4>{translate("My Clients")}</h4>
                <section className="flex wrap">
                    {clients && clients.map((client, index) => {
                        if(!client) return null;

                        return (
                        <Card key={index} className="small">
                            <Link to={`/clients/${client.clientId}`}>{client.name}</Link>
                        </Card>)
                    })}
                </section>

                <section>
                <h4>{translate("Connected administrators")}</h4>
                    <table>
                        <thead>
                            <tr>
                                <th>{translate("Name")}</th>
                                <th>{translate("Email")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {administrators && administrators.map((administrator, index) => {
                                if(!administrator) return null;

                                return (
                                    <tr key={index}>
                                        <td>{administrator.firstName} {administrator.lastName}</td>
                                        <td>{administrator.email}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </section>
            </section>
        </div>
        </>
    )
}